import Vue from "vue";
import Vuex from "vuex";


Vue.use(Vuex);

const axios: any = require("axios");

export default new Vuex.Store({
    state: {
        session: null,
    },
    mutations: {
        uppDateSession(state: any, payload: any): void {
            state.session = payload;
        },
    },
    actions: {
        initialiseStore({ state, commit }: any): void {
            // check if the ID exists
            if (localStorage.getItem("articleshop_store")) {
                // replace the state object with the stored item
                let storeString: any = localStorage.getItem("articleshop_store");
                let savedState: any = Object.assign(state, JSON.parse(storeString));
                this.replaceState(savedState);
            } 
        }
    },
});
